import React from 'react'

import { DefaultMediaWizardLayout } from './DefaultMediaWizardLayout'

import { Benchmarking as BenchmarkingComponent } from 'components/Benchmarking'

import { Breadcrumb } from 'components/Links'


const breadcrumbs: Breadcrumb[] = [
  {
    path: '/wizard/reporting',
    name: 'Reporting',
  },
  {
    path: '/wizard/reporting/benchmarking',
    name: 'Benchmarking',
  },
]


export const Benchmarking = (): JSX.Element => {
  return (
    <DefaultMediaWizardLayout
      breadcrumbs={breadcrumbs}>

      <BenchmarkingComponent />

    </DefaultMediaWizardLayout>
  )
}
